import { combineReducers } from 'redux';

import auth from './auth.reducer';
import autenticacion from './autenticacion.reducer';
import alert from './alert.reducer';
import descargas from './descargas.reducer';
import dispositivos from './dispositivos.reducer';
import users from './users.reducer';
import catalogos from './catalogos.reducer';
import catalogosBeneficiados from './catBeneficiados.reducer';
import catalogoMI from './catalogMI.reducer';
import catFechas from './catFechas.reducer';
import actaCierre from './actaCierre.reducer';
import validarUsuario from './validarUsuario.reducer';
import hallazgo from './modalHallazgoBeneficio.reducer';
import menu from './menu.reducer';
import monitoreosEspectaculares from './monitoreosEspectaculares.reducer';
import monitoreosInternet from './monitoreosInternet.reducer';
import monitoreosEventos from './monitoreosEventos.reducer';
import monitoreosCasas from './monitoreosCasas.reducer';
import notificarPartido from './notificarPartido.reducer';
import pdf from './pdf.reducer';
import plantillas from './templates.reducer';
import monitoreosMediosImp from './monitoreosMediosImp.reducer';
import publicDownloads from './publicDownloads.reducer';
import recursos from './recursos.reducer';
import bitacoraNotificacion from './bitacoraNotificacion.reducer';

export default combineReducers({
  alert,
  catalogoMI,
  catFechas,
  catalogos,
  catalogosBeneficiados,
  descargas,
  dispositivos,
  users,
  auth,
  autenticacion,
  validarUsuario,
  actaCierre,
  hallazgo,
  menu,
  monitoreosEspectaculares,
  monitoreosInternet,
  monitoreosEventos,
  monitoreosCasas,
  monitoreosMediosImp,
  notificarPartido,
  pdf,
  plantillas,
  publicDownloads,
  recursos,
  bitacoraNotificacion
});
